<template>
  <v-card block rounded="0" class="file-uploader">
    <v-row>
      <v-col class="status">
            <div v-if=" fileStatus == 'LOADING' ">
              <Loader />
            </div>
            <div v-if=" fileStatus == 'VALID' ">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M20 10C20 15.523 15.523 20 10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0C15.523 0 20 4.477 20 10Z" fill="#2BB75A"/><path fill-rule="evenodd" clip-rule="evenodd" d="M8.5859 14.6569L10.0001 13.2427L5.75748 9.00009L4.34326 10.4143L8.5859 14.6569Z" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M8.58584 14.6569L15.6569 7.58582L14.2427 6.17161L7.17163 13.2427L8.58584 14.6569Z" fill="white"/></svg>
            </div>
            <div v-if=" fileStatus == 'OPEN' ">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><g opacity="0.25"><path fill-rule="evenodd" clip-rule="evenodd" d="M0 10C0 4.477 4.477 0 10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20C4.477 20 0 15.523 0 10Z" fill="black"/><path fill-rule="evenodd" clip-rule="evenodd" d="M9 9H11V15H9V9ZM9 5H11V7H9L9 5Z" fill="white"/></g></svg>
            </div>
            <div v-if=" fileStatus == 'ERROR' ">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M20 18H0L10 1L20 18Z" fill="#FF6A00"/><path fill-rule="evenodd" clip-rule="evenodd" d="M9 12H11V7H9V12Z" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M9 16H11V14H9V16Z" fill="white"/></svg>
            </div>
            <div v-if=" fileStatus == 'PROCESSING' ">
              <Loader />
            </div>
      </v-col>
      <v-col justify="space-between" class="paneltitle">
        <p><b>{{ inputName }}</b></p>
      </v-col>
      <v-col>
        <div class="part-desc">
          <v-btn tile color="white" :to="toSpecifikation">Spezifikation</v-btn>
        </div>
      </v-col>
      <v-col class="paneluploader">
        <FileUploader :enabled="uploaderEnabled" :id="uploaderElementId" :document='inputFileType' @updatefileid="setFileId($event)" @uploaderError="uploaderError($err)"/>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import FileUploader from '@/components/FileUploader.vue'
import InputFile from '@/services/InputFile'
import Loader from '@/components/Loader.vue'

export default {
  mounted () {
    this.checkFileStatus()
  },
  created () {
    if (this.fileStatus === 'PROCESSING') {
      this.startReloadTimer()
    } else {
      this.stopReloadTimer()
    }
  },
  data () {
    return {
      fileStatus: 'LOADING',
      fileId: '',
      unitId: this.$unit.uuid,
      fileName: '',
      createDate: '',
      timer: '',
      uploaderEnabled: false
    }
  },
  props: ['uploaderElementId', 'inputFileType', 'inputName', 'toSpecifikation'],
  components: {
    FileUploader,
    Loader
  },
  methods: {
    openEditForm () {
      this.$router.replace({ path: '/file/' + this.inputFileType })
    },
    startReloadTimer () {
      this.timer = setInterval(this.checkFileStatus, 1000)
    },
    stopReloadTimer () {
      clearInterval(this.timer)
    },
    openUpload () {
      this.fileStatus = 'OPEN'
    },
    async setFileId (fileId) {
      this.fileId = fileId
      this.checkFileStatus()
    },
    async uploaderError (msg) {
      this.fileStatus = 'ERROR'
      this.fileId = ''
      this.createDate = ''
      this.fileName = ''
    },
    async checkFileStatus () {
      // this.fileStatus = 'LOADING'
      this.stopReloadTimer()
      // console.log('reload ', this.inputFileType)
      const responce = await InputFile.fileStatus(this.fileId, this.unitId, this.inputFileType)
      // console.log('loading done ', this.inputFileType)
      // console.log(responce)
      if (responce.data) {
        const resData = responce.data
        const options = { year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric' }
        const fileDate = new Date(resData.created)

        this.fileStatus = resData.status
        this.fileId = resData.fileId
        this.createDate = fileDate.toLocaleDateString('de-CH', options)
        this.fileName = resData.name
      } else {
        this.fileStatus = 'OPEN'
        this.uploaderEnabled = true
        this.fileId = ''
        this.createDate = ''
        this.fileName = ''
      }

      if (this.fileStatus === 'PROCESSING') {
        this.uploaderEnabled = false
        this.startReloadTimer()
      } else {
        this.uploaderEnabled = true
        this.stopReloadTimer()
      }
    }
  }
}
</script>

<style scoped>
.file-uploader {
  background-color: white;
  /* box-shadow: 0 3px 1px -2px rgb(0 0 0 / 20%), 0 2px 2px 0 rgb(0 0 0 / 14%), 0 1px 5px 0 rgb(0 0 0 / 12%); */
  margin-bottom: 20px;
  padding: 15px;
}
.ready {
  background-color: #e2d79a;
}
.loading {
  background-color: #d8d8d8;
}
.error {
  background-color: #ffb9b9;
}
.status {
  align-items: center;
  justify-content: center;
  margin-top: auto;
  text-align: center;
  max-width: 60px;
}
.paneltitle {
  display: flex;
  align-items: center;
  justify-content: left;
}
.paneluploader {
  width: 135px;
}
.paneltitle p {
  margin: 0
}
.part-desc {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/InputFile.vue